export const MANAGE_USER_PERMISSIONS_ID = "87";

export const normalizePermissionIds = (ids = []) => [...new Set(ids.map(String))];

export const getPermissionCapabilities = (actor, target) => {
  const isAdministrator = actor?.tipoUser === "Administrador";
  const canManagePermissions =
    (isAdministrator ||
      actor?.permisos?.some((p) => String(p.id) === MANAGE_USER_PERMISSIONS_ID)) &&
    (isAdministrator || target?.tipoUser !== "Administrador");
  return {
    isAdministrator,
    canManagePermissions: Boolean(canManagePermissions),
    canEditPermission: (id) =>
      Boolean(
        canManagePermissions && (isAdministrator || String(id) !== MANAGE_USER_PERMISSIONS_ID)
      ),
  };
};

// Una plantilla reemplaza permisos comunes, pero no delega ni revoca el 87.
export const applyPermissionTemplate = (ids, originalIds, isAdministrator) => {
  const next = normalizePermissionIds(ids);
  if (isAdministrator) return next;
  const common = next.filter((id) => id !== MANAGE_USER_PERMISSIONS_ID);
  return normalizePermissionIds(originalIds).includes(MANAGE_USER_PERMISSIONS_ID)
    ? [...common, MANAGE_USER_PERMISSIONS_ID]
    : common;
};

export const togglePermissionGroup = (selected, group, canEditPermission) => {
  const editable = group.map((p) => String(p.id)).filter(canEditPermission);
  const current = normalizePermissionIds(selected);
  if (editable.length === 0) return current;
  const remaining = current.filter((id) => !editable.includes(id));
  return editable.every((id) => current.includes(id)) ? remaining : [...remaining, ...editable];
};
